import { useState } from "react";
import { Trans } from "react-i18next";
import { Box, IconButton, Typography } from "@mui/material"
import { theme } from "../../../utils/theme/godzilla_light"
import { EDUCATION_HUB_CONTENT_MAX_WIDTH } from "../constants"
import { AccordionComponent } from "../../../components";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const styles = {
    expandIcon: {
        boxShadow: '0px 1px 5px 0px rgba(37, 37, 37, 0.12), 0px 2px 2px 0px rgba(37, 37, 37, 0.14), 0px 3px 1px -2px rgba(37, 37, 37, 0.20)',
        width: "45px",
        height: "45px",
        borderRadius: "100px",
        display: "flex",
        justifyContent: "center",
        alignItems: 'center',
    },
    referLabel: {
        ...theme.typography.poppinsBodyLight,
        fontSize: "14px"
    }
}

interface IReferanceCardProps {
    referanceData?: any[];
    wrapperSx?: any;
}
const ExpandIconComponent = ({ onClick, showAll }: { onClick: any, showAll: boolean }) => (
    <IconButton onClick={onClick}>
        <Box sx={styles.expandIcon}>
            <ExpandMoreIcon sx={{ color: "#000", transform: showAll ? 'rotate(0deg)' : 'rotate(180deg)', }} />
        </Box>
    </IconButton>
)

const ReferanceCard = (props: IReferanceCardProps) => {
    const { referanceData, wrapperSx } = props;
    const [showAll, setShowAll] = useState(false)

    const referanceList = referanceData && referanceData?.length > 0 && showAll ? referanceData : referanceData?.slice(0, 5)

    const toggleShowMore = (e: any) => {
        e.stopPropagation();
        setShowAll((prev) => !prev);
    };

    return (
        <Box sx={{ backgroundColor: "#fff", py: "57px", ...wrapperSx }} textAlign={"left"} display="flex" flexDirection={"column"} justifyContent={"center"} alignItems={"center"}>
            <Box maxWidth={EDUCATION_HUB_CONTENT_MAX_WIDTH} width="100%">
                <AccordionComponent
                    title="References"
                    defaultExpanded
                    titleSx={{ ...theme.typography.opticianBodyRegular, fontSize: "24px", color: "#393939" }}
                    wrapperSx={{ boxShadow: "none" }}
                    customExpandIcon={<ExpandIconComponent onClick={toggleShowMore} showAll={showAll} />}>
                    <Box mt={"5px"}>
                        {referanceList?.map((items, index) => {
                            return (
                                <Box key={index + 1} sx={{ pb: "1.5px" }} display={"flex"}>
                                    <Typography sx={{ ...styles.referLabel, pr: "6px" }} >
                                        {index + 1}.
                                    </Typography>
                                    <Typography sx={{ ...styles.referLabel, whiteSpace: "pre-line" }} component="span">
                                        <Trans
                                            i18nKey={items}
                                            components={{
                                                em: <em />,
                                            }}
                                        />
                                    </Typography>
                                </Box>
                            )
                        })}
                    </Box>
                </AccordionComponent>
            </Box>
        </Box>
    )
}

export default ReferanceCard